import React from 'react'
import { observer } from 'mobx-react'
import { Typography } from 'antd'

export const WizardStepSubTitle = observer(({subTitle}: any) => {
    const { Title } = Typography;
    return <>{subTitle && <Title level={5} className='wizard__subTitle text-left font-normal py-24' style={{marginBottom: 0}}>{subTitle}</Title>}</>
})